const semanticClassNames = {
  root: 'switch',
  label: 'switch__label',
  track: 'switch__track',
  handle: 'switch__handle',
} as const;

export default semanticClassNames;
